import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import HelpIconPopover from '../HelpIconPopover';

import '../../../styles/report.css'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2'

ChartJS.register(ArcElement, Tooltip, Legend);

/*
  Using a <style> tag directly in a component is generally not standard practice,
  but it is the most effective way to encapsulate print-only styles within a single
  file modification as requested. The @media print query ensures these styles
  do not affect the on-screen display.
*/
const PrintStyles = () => (
    <style>
        {`
        @media print {
            .ha-print-container {
                background-color: #fff;
                page-break-inside: avoid;
                margin-top: 16px;
            }

            .ha-print-container .ha-title {
                font-family: 'Times New Roman', Times, serif;
                font-size: 16pt;
                font-weight: bold;
                text-align: center;
                color: #000;
                margin-bottom: 8px;
            }

            .ha-print-container .ha-values-grid {
                display: grid;
                grid-template-columns: 1fr 1fr;
                text-align: center;
                margin-top: 8px;
            }
            
            .ha-print-container .ha-value-label {
                font-family: 'Times New Roman', Times, serif;
                font-size: 11pt;
                color: #333;
            }

            .ha-print-container .ha-value-score {
                font-family: 'Times New Roman', Times, serif;
                font-size: 14pt;
                font-weight: bold;
                color: #000;
            }

            /* Ensure the interactive popover is not visible in print */
            .ha-print-container .help-icon-popover {
                display: none;
            }
        }
        `}
    </style>
);


const HealthAge = (props) => {
    const { OWS, PrintView } = props;

    // This nested component renders the chart
    const WellnessScore = (props) => {
        const { CurrentOWSValue, ActualAge, PrintView } = props;
        const HAge = CurrentOWSValue;
        const healthAgeGreater = HAge > ActualAge;

        const ColorBase = '#D2EDD1';
        const Color = '#4eb748';
        const Color2 = '#E6323A';
        
        const data = {
            labels: ["Health Age"],
            datasets: [
                {
                    label: 'Age',
                    data: [ActualAge],
                    backgroundColor: [ColorBase],
                    borderColor: ['rgba(54, 162, 235, 0)'],
                    borderSkipped: false,
                    borderWidth: 0,
                },
                {
                    label: 'Health Age',
                    data: [Math.abs(HAge - ActualAge)],
                    backgroundColor: [healthAgeGreater ? Color2 : Color],
                    borderColor: ['rgba(54, 162, 235, 0)'],
                    borderSkipped: false,
                    borderWidth: 0,
                }
            ],
        }
        
        const options = {
            animation: PrintView ? false : true, // Disable animation for print
            tooltips: { enabled: false },
            hover: { mode: null },
            borderWidth: 0,
            maintainAspectRatio: false,
            indexAxis: 'y',
            scales: {
                y: {
                    beginAtZero: true,
                    stacked: true,
                    grid: { display: false, drawBorder: false },
                    ticks: { display: false }
                },
                x: {
                    stacked: true,
                    grid: { display: false, drawBorder: false },
                    ticks: { display: false }
                }
            },
            plugins: {
                legend: {
                    display: false
                },
            },
        }

        return <Bar data={data} options={options} />
    }
    
    if (PrintView === true) {
        return (
            <>
                <PrintStyles />
                <div className="ha-print-container">
                    <div className="ha-title">{OWS.HealthAge.Label}</div>
                    <Box sx={{ height: '50px' }}> {/* Set a fixed height for the chart container */}
                         <WellnessScore CurrentOWSValue={OWS.HealthAge.Score} ActualAge={OWS.HealthAge.Age} PrintView={true} />
                    </Box>
                    <div className="ha-values-grid">
                        <div className="ha-value-item">
                            <div className="ha-value-label">{OWS.HealthAge.Label}</div>
                            <div className="ha-value-score">{OWS.HealthAge.Score}</div>
                        </div>
                        <div className="ha-value-item">
                             <div className="ha-value-label">{OWS.HealthAge.AgeLabel}</div>
                            <div className="ha-value-score">{OWS.HealthAge.Age}</div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <Box>
            {props.OWS.HealthAge.HelpText !== '' && (
                <Typography variant="body1" fontWeight="bold" style={{ textAlign: 'center', fontSize: "20px" }}>
                    {props.OWS.HealthAge.Label}
                    <span className="help-icon-popover">
                        <HelpIconPopover Text={props.OWS.HealthAge.HelpText} style={{ top: '-10!important' }} />
                    </span>
                </Typography>
            )}

            <Box >
                <Box sx={{ height: '50px' }}>
                    <WellnessScore CurrentOWSValue={props.OWS.HealthAge.Score} ActualAge={props.OWS.HealthAge.Age} PrintView={false} />
                </Box>
                <Grid container direction="row" alignItems={"center"} justifyContent={"center"}>
                    <Grid item xs={12} md={6}>
                        <Typography align="center" variant="subtitle2">{props.OWS.HealthAge.Label}</Typography>
                        <Typography align="center" variant="h5">{props.OWS.HealthAge.Score}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography align="center" variant="subtitle2">{props.OWS.HealthAge.AgeLabel}</Typography>
                        <Typography align="center" variant="h5">{props.OWS.HealthAge.Age}</Typography>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default HealthAge;